module.exports = __webpack_public_path__ + "static/media/card-bg-weak.52c5977c.png";